"use client";

import { Skeleton } from "@/components/desktop/ui";
export function WindowSkeleton() {
  return <div className="flex flex-col h-full p-4 bg-surface" data-sentry-component="WindowSkeleton" data-sentry-source-file="WindowSkeleton.tsx">
            <Skeleton className="h-6 w-32 mb-4" data-sentry-element="Skeleton" data-sentry-source-file="WindowSkeleton.tsx" />
            <Skeleton className="h-8 w-full mb-2" data-sentry-element="Skeleton" data-sentry-source-file="WindowSkeleton.tsx" />
            <div className="flex-1 space-y-2">
                {Array.from({
        length: 8
      }).map((_, i) => <Skeleton key={i} className="h-12 w-full" />)}
            </div>
        </div>;
}